var map = {
	"./Contact": 2923,
	"./Contact.vue": 2923,
	"./Home": 4270,
	"./Home.vue": 4270,
	"./Legals/Accessibility": 8761,
	"./Legals/Accessibility.vue": 8761,
	"./Legals/Privacy": 2145,
	"./Legals/Privacy.vue": 2145,
	"./Products/Index": 9638,
	"./Products/Index.vue": 9638,
	"./Products/Show": 9327,
	"./Products/Show.vue": 9327,
	"./Recipes/Index": 4988,
	"./Recipes/Index.vue": 4988,
	"./Recipes/Show": 1076,
	"./Recipes/Show.vue": 1076,
	"./Retailers": 2606,
	"./Retailers.vue": 2606
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8846;